var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "aiShop" }, [
    _c(
      "div",
      { staticClass: "filterTop" },
      [
        _c(
          "el-input",
          {
            staticStyle: { width: "378px", height: "40px" },
            attrs: { size: "medium", placeholder: "请输入要查找的助手名称" },
            on: { input: _vm.onsearch },
            model: {
              value: _vm.search.keyWord,
              callback: function ($$v) {
                _vm.$set(_vm.search, "keyWord", $$v)
              },
              expression: "search.keyWord",
            },
          },
          [
            _c("i", {
              staticClass: "el-input__icon el-icon-search",
              attrs: { slot: "prefix" },
              slot: "prefix",
            }),
          ]
        ),
        _c(
          "div",
          { staticClass: "clearBtn", on: { click: _vm.onhandleClear } },
          [_vm._v("重置")]
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "aishop-tab" },
      [
        _c(
          "el-tabs",
          {
            on: { "tab-click": _vm.onsearch },
            model: {
              value: _vm.categorys.cur,
              callback: function ($$v) {
                _vm.$set(_vm.categorys, "cur", $$v)
              },
              expression: "categorys.cur",
            },
          },
          [
            _vm._l(_vm.categorys.list, function (item) {
              return [
                _c("el-tab-pane", {
                  key: item.categoryId,
                  attrs: { label: item.name, name: String(item.categoryId) },
                }),
              ]
            }),
          ],
          2
        ),
      ],
      1
    ),
    _c("div", { staticClass: "aiShop-content" }, [
      _c(
        "div",
        {
          directives: [
            {
              name: "infinite-scroll",
              rawName: "v-infinite-scroll",
              value: _vm.load,
              expression: "load",
            },
          ],
          staticClass: "aiShop-list",
          attrs: {
            "infinite-scroll-disabled": "disabled",
            "infinite-scroll-distance": 50,
          },
        },
        [
          _c(
            "div",
            { staticClass: "ailist-body" },
            _vm._l(_vm.aiList, function (item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "ailist_view",
                  on: {
                    mouseover: function ($event) {
                      item.showBtnUser = true
                    },
                    mouseleave: function ($event) {
                      item.showBtnUser = false
                    },
                    click: function ($event) {
                      return _vm.onhandleUse(item)
                    },
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "ailist_view_img" },
                    [
                      item.id === "1"
                        ? _c("img", {
                            attrs: {
                              src: require("@/assets/image/aigc/my_icon.png"),
                              alt: "",
                            },
                          })
                        : [
                            !!item.icon
                              ? _c("img", {
                                  attrs: { src: item.icon, alt: "" },
                                })
                              : _c(
                                  "div",
                                  {
                                    staticClass: "title-span",
                                    style: { background: item.backgroundColor },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { style: { color: item.textColor } },
                                      [_vm._v(_vm._s(item.title.split("")[0]))]
                                    ),
                                  ]
                                ),
                          ],
                    ],
                    2
                  ),
                  _c("div", { staticClass: "ailist_detail" }, [
                    _c(
                      "div",
                      { staticClass: "ailist_detail_title" },
                      [
                        _c("textShowMore", {
                          attrs: { "line-clamp": 1, text: item.title },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "ailist_detail_describe" },
                      [
                        _c("textShowMore", {
                          attrs: {
                            "line-clamp": 2,
                            text:
                              item.templateId === "1"
                                ? "全能AI小助手，解决你的所有问题"
                                : item.description,
                          },
                        }),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "ailist_detail_footer" }, [
                      _c("div", { staticClass: "ailist_detail_footer_des" }, [
                        _c("div", [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/image/aigc/aiCreater.png"),
                            },
                          }),
                          _c("span", [_vm._v(_vm._s(item.createdNickName))]),
                        ]),
                        _c("div", [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/image/aigc/aiHot.png"),
                            },
                          }),
                          _c("span", [_vm._v(_vm._s(item.useCounter))]),
                        ]),
                      ]),
                    ]),
                    item.hasUsed || item.id === "1"
                      ? _c("div", { staticClass: "aiUseingTips" }, [
                          _vm._v(" 使用中 "),
                        ])
                      : _vm._e(),
                  ]),
                ]
              )
            }),
            0
          ),
          _vm.aiList.length === 0 && _vm.noMore && !_vm.loading
            ? _c("div", { staticClass: "noData" }, [
                _c("img", {
                  attrs: { src: require("@/assets/image/aiIcon.gif"), alt: "" },
                }),
                _c("div", { staticClass: "noDataText" }, [
                  _vm._v("未搜索到相关结果"),
                ]),
              ])
            : _vm._e(),
        ]
      ),
      _vm.loading
        ? _c("div", { staticClass: "aiShop-loading" }, [
            _c("img", {
              attrs: { src: require("@/assets/image/aigc/loading.gif") },
            }),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }